import { inject } from "@angular/core";
import { finalize } from "rxjs";
import { HttpInterceptorFn } from "@angular/common/http";

import { systemLoader } from "@azm/core/services/http";
import { LoadingService } from "@azm/core/services/loading";

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
	const loadingService = inject(LoadingService);

	if (req.url.includes(".json")) return next(req);

	const useSystemLoader = req.context.get(systemLoader) === "loader";
	if (useSystemLoader) loadingService.setLoading(true, req.url);
	return next(req).pipe(
		finalize(() => {
			if (useSystemLoader) loadingService.setLoading(false, req.url);
		}),
	);
};
